import { HTTP_METHOD } from '@nxt-insurance/api-service'

import dog_breed_type from '@flows/configs/dogLiabilityNxt/steps/dogList/dogListPopupElements/dog_breed_type'
import dog_breeds from '@flows/configs/dogLiabilityNxt/steps/dogList/dogListPopupElements/dog_breeds'
import dog_name from '@flows/configs/dogLiabilityNxt/steps/dogList/dogListPopupElements/dog_name'
import { dogListSchema } from '@flows/configs/dogLiabilityNxt/steps/dogList/dog_list_schemas'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dog_list = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('dogs')]: dogListSchema.array().nonempty(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.title',
        },
      },
      {
        type: 'editableList',
        maximumItems: 10,
        name: params.helperFunctions.getParamPath('dogs'),
        addItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.start.add_dog',
        },
        startText: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.start.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.start.title',
        },
        // We use this field value for list item title
        editableListItemTitleKey: 'name',
        popupConfiguration: {
          title: {
            type: 'translatableText',
            translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.popup.title',
          },
          // dog list popup form validation
          schema: dogListSchema,
          elements: [...dog_name(), ...dog_breed_type(), ...dog_breeds(params)],
        },
      },
    ],
    nextStep: 'dog_owner_age',
    subFlow: params.subFlow,

    onPrepare: {
      type: 'simpleHook',
      callback: async () => {
        const URL = `/api/v2/markets/${params.clientHelpers.getMarket()}/products/${
          params.productKey
        }/configuration_params_options`

        const response = await params.clientHelpers.apiService.call({
          serviceName: 'insurance',
          method: HTTP_METHOD.GET,
          url: URL,
        })

        const breeds = response.data.dogs.breeds.map(({ breed }: { breed: string }) => ({
          label: { type: 'nonTranslatableText' as const, text: breed },
          value: breed,
        }))

        const otherBreed = {
          value: 'Other',

          label: {
            type: 'translatableText' as const,
            translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.options.other',
          },
        }

        return {
          formValues: {
            [params.helperFunctions.getTransientPath('breeds')]: [...breeds, otherBreed],
          },
        }
      },
    },
  }) as const satisfies AnyStepConfiguration

export default dog_list
